<template>
  <form novalidate @submit.prevent="validate">
    <md-card v-if="dadosAba">
      <md-card-header>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-100">
            <md-field>
              <label>Aluno</label>
              <md-input :value="aluno.codigoAluno + '' + aluno.codigoEspecialidade + ' - ' + aluno.nomeAluno" disabled></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <md-field>
              <label>Especialidade atual</label>
              <md-input :value="aluno.codigoEspecialidade + ' - ' + aluno.descricaoEspecialidade" disabled></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-25 md-small-size-50">
            <md-field>
              <label>Turma atual</label>
              <md-input :value="aluno.codigoTurma" disabled></md-input>
            </md-field>
          </div>
        </div>
      </md-card-header>

      <md-card-content>
        <div class="md-layout md-gutter">

          <div class="md-layout-item md-size-100">
            <md-autocomplete v-model="curso" :md-options="listCursos" md-dense>
              <label>Curso</label>
              <template slot="md-autocomplete-item" slot-scope="{ item, term }">
                <md-highlight-text :md-term="term">{{item}}</md-highlight-text>
              </template>
              <template slot="md-autocomplete-empty" slot-scope="{ term }">
                Nenhum curso encontrado para o filtro "{{ term }}".
              </template>
            </md-autocomplete>
          </div>

          <div class="md-layout-item md-size-33 md-small-size-50">
            <Loading v-bind:show="loadingTurmas">
              <md-field>
                <label for="turma">Turma nova / Período</label>
                <md-select v-model="turma" name="turma" id="turma" :disabled="!curso">
                  <md-optgroup v-for="gp in listTurmasAgrupadas"
                               :key="gp.situacao"
                               :label="gp.situacao"
                               :disabled="gp.situacao.toLocaleLowerCase() == 'encerrada' || gp.situacao.toLocaleLowerCase() == 'formada'">
                    <md-option v-for="item in gp.turmas" :key="item" :value="item">{{item}}</md-option>
                  </md-optgroup>
                </md-select>
              </md-field>
            </Loading>
          </div>

          <!--<div class="md-layout-item md-size-33 md-small-size-50">
            <div>Motivo da troca:</div>
            <md-radio v-model="form.motivo" class="md-primary" value="Reprova">Reprova</md-radio>
            <md-radio v-model="form.motivo" class="md-primary" value="Analise Curricular">Análise Curricular</md-radio>
          </div>-->
        </div>
      </md-card-content>

      <md-progress-bar md-mode="indeterminate" v-if="sending" />

      <md-card-actions>
        <md-button class="md-text-and-icon md-raised md-primary" @click="save">
          <md-icon>check</md-icon>Salvar
        </md-button>
        <md-button class="md-text-and-icon md-raised md-error" @click="$emit('fechar')">
          <md-icon>cancel</md-icon>Cancelar
        </md-button>
      </md-card-actions>
    </md-card>
  </form>
</template>
<script>
  import Loading from '@/components/Loading';
  import TrocaTurmaService from '@/services/TrocaTurmaService.js';


  export default {
    props: {
      aluno: Object,
      dadosAba: Object
    },
    components: {
      Loading
    },
    data() {
      return {
        periodo: "Todos",
        curso: '',
        turmas: [],
        turma: '',
        validacoes: {
          turma: null
        },
        sending: false,
        loadingTurmas: false
      }
    },
    computed: {
      listCursos() {
        let cursos = [];
        if (this.dadosAba?.cursos) {
          for (var i = 0; i < this.dadosAba.cursos.length; i++) {
            cursos.push(`${this.dadosAba.cursos[i].codigoEspecialidade} - ${this.dadosAba.cursos[i].descricaoEspecialidade} (${this.dadosAba.cursos[i].tipoEspecialidadeExtenso})`);
          }
        }

        return cursos;
      },

      listTurmasAgrupadas() {
        let turmasAgrupadas = [];
        if (this.turmas?.length > 0) {

          let situacoes = [...new Set(
            this.turmas.map(
              item => item.descricaoSituacao
            )
          )].sort();

          for (var s = 0; s < situacoes.length; s++) {
            let gp = {
              situacao: situacoes[s],
              turmas: []
            };

            for (var i = 0; i < this.turmas.length; i++) {
              if (this.turmas[i].descricaoSituacao == gp.situacao)
                gp.turmas.push(`${this.turmas[i].codigoTurma} / ${this.turmas[i].periodo}`);
            }

            turmasAgrupadas.push(gp);
          }
        }

        return turmasAgrupadas;
      },

      turmaNova() {
        let turmaNova = '';

        if (this.turma) {
          //Trata o valor pra pegar a turma nova
          turmaNova = this.turma.split('/')[0].trim();
        }

        return turmaNova;
      }
    },
    watch: {
      curso(novo) {
        if (novo) {
          this.loadingTurmas = true;

          let codigoEspecialidade = novo.split('-')[0].trim();
          this.trocaTurmaService.ListaTurmasPorEspecialidade(codigoEspecialidade).then(
            data => {
              if (data.ok) {
                this.turmas = data.dados;
              }
              else {
                this.$notify.showInfinite('center', data.Mensagem);
              }
            },
            error => {
              if (error.status != 500)
                this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
              else
                this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
            }).finally(() => {
              this.loadingTurmas = false;
            });
        }
        else {
          this.turma = "";
          this.turmas = [];
        }
      }
    },
    created() {
      this.trocaTurmaService = new TrocaTurmaService(this);
    },

    methods: {
      getValidationClass(fieldName) {
        const field = this.$v.form[fieldName]

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },

      clearForm() {
        this.curso= '';
        this.turmas= [];
        this.turma= '';
        this.validacoes = {
          turma: null
        };
      },

      save() {

        if (this.turmaNova) {
          this.sending = true
          this.trocaTurmaService.TrocaTurmaEspecialidade({
            codigoAluno: this.aluno.codigoAluno,
            codigoEspecialidadeAtual: this.aluno.codigoEspecialidade,
            turmaDestino: this.turmaNova
          }).then(
            data => {
              if (data.ok) {
                this.$notify.showDuration('center', 4000, 'Troca de turma realizada com sucesso!');
                this.clearForm();
                this.$emit("fechar");
              }
              else {
                this.$notify.showInfinite('center', data.Mensagem);
              }
            },
            error => {
              if (error.status != 500)
                this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
              else
                this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
            }).finally(() => {
              this.sending = false;
            });
        }
        else {
          this.$modal.alert("É necessário informar a turma nova.");
        }
      }
    }
  }
</script>


<style scoped>
  .autocomplete {
    width: auto;
  }
</style>